<template>
  <div class="relative">
      <div v-show="errorMessage.length > 0">
          <div class="text-red-600">
              {{ errorMessage }}
          </div>
          <hr/>
      </div>

      <div v-show="promisePending && errorMessage.length === 0" class=" absolute top-0 right-0 animate-spin text-center flex justify-center items-center">
          <i class=" fas fa-spinner w-6 h-6"></i>
      </div>

      <div>
          <label for="pipedream_url">URL du workflow Pipedream</label>
          <input
          id="pipedream_url"
          class="rounded-md p-1 w-full leading-relaxed mb-2"
          v-model="pipedream_url"
          placeholder="URL du workflow Pipedream"/>
          <hr/>
      </div>

      <div>

          <label for="target_smd_table">Importer vers...</label>
          <input
          id="target_smd_table"
          class="rounded-md p-1 w-full leading-relaxed mb-2"
          v-model="smd_table"
          placeholder="Nom de la nouvelle table SMD"/>
          <hr/>
      </div>

      <div class=" flex justify-center items-center">
          
          <button
          class="rounded-md p-1 leading-relaxed mb-2 bg-slate-100  "
          :class="{ 'hover:bg-slate-200': toggle_raw_body === false}"
          :disabled="toggle_raw_body === true"
          @click="bodyParams.push({ key: '', value: '' })">
          
              Ajouter un paramètre
              <i class=" fa fa-plus">
              </i>
          </button>

          <!-- Toggle raw json button -->
          <div class=" absolute right-10">
              <b-form-checkbox v-model="toggle_raw_body" switch>
                  JSON brut
              </b-form-checkbox>
          </div>
          
      </div>

      <!-- JSON brut option -->
      <div v-show="toggle_raw_body">
          <b-form-textarea
          id="pipedream_body"
          class="rounded-md p-1 w-full leading-relaxed mb-2"
          rows="5"
          v-model="raw_body"
          placeholder="JSON brut de la requête Pipedream">
      </b-form-textarea>

      </div>

      <!-- Body params -->
      <div v-show="!toggle_raw_body">
          <div v-for="(bodyParam, idx) in bodyParams"
              :key="'body-param-' + idx"
              class="flex justify-around relative">
              <div class="w-[45%]">
                  <label for="body-param-key">Clé</label>
                  <input
                  id="body-param-key"
                  class="rounded-md p-1 w-full leading-relaxed mb-2"
                  v-model="bodyParam.key"
                  placeholder="Clé"/>
              </div>
              <div class="w-[45%]">
                  <label for="body-param-value">Valeur</label>
                  <input
                  id="body-param-value"
                  class="rounded-md p-1 w-full leading-relaxed mb-2"
                  v-model="bodyParam.value"
                  placeholder="Valeur"/>

              <i class=" cursor-pointer absolute top-[50%] text-red-400 right-0 fas fa-trash hover:text-red-500"
                  @click="() => bodyParams.splice(idx, 1)">

              </i>
              </div>
          </div>
      </div>

      <b-button
          :disabled="!filled_body_params"
          @click="() => import_pipedream()"
          variant="success">{{ "Importer" }}</b-button>
  </div>

</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import pipedream_service from '../../services/pipedream';

const pipedream_url = ref("");
const smd_table = ref("");

const bodyParams = ref([
  {
      key: "",
      value: ""
  }
]); // [ { key: value } ]

const raw_body = ref("");
const toggle_raw_body = ref(false);

const errorMessage = ref("");
const promisePending = ref(false);

const filled_body_params = computed(() => {
  
  if (toggle_raw_body.value && raw_body.length === 0) {
      return false;
  }

  if (smd_table.length === 0) {
      return false;
  }
  if (pipedream_url.length === 0) {
      return false;
  }

  if (bodyParams.length === 0) {
      return false;
  }
  return true;
});

const emits = defineEmits(["validated"]);

const import_pipedream = async () => {
  const url = pipedream_url.value;
  let params = {};

  errorMessage.value = "";
  promisePending.value = true;

  bodyParams.value.forEach((param) => {
      params[param.key] = param.value;
  });

  if (toggle_raw_body.value) {
      try {
          params = JSON.parse(raw_body.value);
      } catch (error) {
          // write an error message
          console.log(error);
          errorMessage.value = "Le JSON brut est invalide";
          return;
      }
  }

  let data = { "pipedream_url": url, "pipedream_body": params, "table_name": smd_table.value}

  await pipedream_service.import_data(data)
  .then((response) => {
      console.log(response);
      promisePending.value = false;
      emits("validated");
  })
  .catch((error) => {
      console.log(error);
      promisePending.value = false;
      errorMessage.value = "Erreur de récupération, vérifiez vos données";
      // write an error message
  });
};

onMounted(() => {

});

</script>